import { Component } from '@angular/core';

@Component({
  selector: 'app-shared-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss'],
})
export class ContainerComponent {}
